import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { getEventLink, getConferenceLocation } from 'theme/utils/generic-helpers'
import Subscribe from '../../subscribe'
import UXDXLogo from 'src/images/uxdx-logo.svg'

function Footer() {
  const handleShowPreferences = () => {
    // console.log('calling')
    if (typeof window.showCookiePreferences === 'function') {
      window.showCookiePreferences()
    }
  }
  return (
    <footer className="bg-gray-800 z-10">
      <div className="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="grid grid-cols-2 gap-8 xl:col-span-2">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <img
                  className="h-10 w-10"
                  src={UXDXLogo}
                  alt="
                  UXDX logo"
                />
                <p className="text-gray-300 pt-2 w-32">
                  Our mission is to help 1 million teams shift from projects to product teams.
                </p>
              </div>
              <div className="mt-12 md:mt-0">
                <h4 className="text-base leading-5 font-semibold text-gray-400 tracking-wider uppercase">
                  Company
                </h4>
                <ul className="mt-4 space-y-4">
                  <li>
                    <Link to="/about" className="text-base leading-6 text-gray-300 hover:text-white">
                      About UXDX
                    </Link>
                  </li>
                  <li>
                    <Link to="/careers" className="text-base leading-6 text-gray-300 hover:text-white">
                      Careers
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" className="text-base leading-6 text-gray-300 hover:text-white">
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div className="">
                <h4 className="text-base leading-5 font-semibold text-gray-400 tracking-wider uppercase">
                  Content
                </h4>
                <ul className="mt-4 space-y-4">
                  <li>
                    <Link to="/model" className="text-base leading-6 text-gray-300 hover:text-white">
                      Model
                    </Link>
                  </li>
                  <li>
                    <Link to="/knowledge" className="text-base leading-6 text-gray-300 hover:text-white">
                      Knowledge Center
                    </Link>
                  </li>
                  <li>
                    <Link to="/blog" className="text-base leading-6 text-gray-300 hover:text-white">
                      Blog
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h4 className="text-base leading-5 font-semibold text-gray-400 tracking-wider uppercase">
                  Get Involved
                </h4>
                <ul className="mt-4 space-y-4">
                  <li>
                    <Link to="/speak" className="text-base leading-6 text-gray-300 hover:text-white">
                      Speak at UXDX
                    </Link>
                  </li>
                  <li>
                    <Link to="/partner" className="text-base leading-6 text-gray-300 hover:text-white">
                      Partner with UXDX
                    </Link>
                  </li>
                  <li>
                    <Link to="/leaderApply" className="text-base leading-6 text-gray-300 hover:text-white">
                      Community Leader
                    </Link>
                  </li>
                  <li>
                    <Link to="/volunteerApply" className="text-base leading-6 text-gray-300 hover:text-white">
                      Volunteer
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="mt-8 xl:mt-0">
            <h4 className="text-base leading-5 font-semibold text-gray-400 tracking-wider uppercase sr-only">
              Join 20,000 others who are scaling their careers with weekly insights
            </h4>
            <p className="text-base leading-5 font-semibold text-gray-400 tracking-wider uppercase">
              &quot;UXDX is my favourite newsletter. Incredible content across the key areas in our
              industry.&quot;
            </p>
            <div className="mt-4 sm:max-w-md">
              <Subscribe
                id="home-footer"
                options={[
                  {
                    name: 'newsletter',
                    title: 'I agree to receive emails from UXDX',
                  },
                  {
                    name: 'apac',
                    title: 'APAC Announcements & Special Offers',
                    default: true,
                  },
                  {
                    name: 'emea',
                    title: 'EMEA Announcements & Special Offers',
                    default: true,
                  },
                  {
                    name: 'usa',
                    title: 'USA Announcements & Special Offers',
                    default: true,
                  },
                ]}
              />
            </div>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-700 pt-8 md:flex md:items-center md:justify-between pb-10">
          <div className="md:order-1 pb-8 md:pb-0  md:order-1">
            <ul className="flex">
              <li className="footer-item">
                <Link to="/ticket-terms/" className="text-sm mr-2 leading-6 text-gray-300 hover:text-white">
                  Terms
                </Link>
              </li>
              <li className="footer-item">
                <Link to="/privacy/" className="text-sm mr-2 leading-6 text-gray-300 hover:text-white">
                  Privacy
                </Link>
              </li>
              <li className="footer-item">
                <Link to="/cookie-policy/" className="text-sm mr-2 leading-6 text-gray-300 hover:text-white">
                  Cookie Policy
                </Link>
              </li>
              <li className="footer-item">
                <button
                  onClick={handleShowPreferences}
                  className="text-sm mr-2 leading-6 text-gray-300 hover:text-white"
                >
                  <span className="footer-item-text">Cookie settings</span>
                </button>
              </li>
              <li className="footer-item">
                <Link
                  to="/code-of-conduct/"
                  className="text-sm mr-2 leading-6 text-gray-300 hover:text-white"
                >
                  Code of Conduct
                </Link>
              </li>
            </ul>
          </div>
          <div className="flex space-x-6 md:order-2">
            <a
              href="https://www.linkedin.com/company/uxdx"
              target="_blank"
              rel="noreferrer noopener"
              className="text-gray-400 hover:text-gray-300"
            >
              <span className="sr-only">LinkedIn</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10,0.4c-5.302,0-9.6,4.298-9.6,9.6s4.298,9.6,9.6,9.6s9.6-4.298,9.6-9.6S15.302,0.4,10,0.4z M7.65,13.979 H5.706V7.723H7.65V13.979z M6.666,6.955c-0.614,0-1.011-0.435-1.011-0.973c0-0.549,0.409-0.971,1.036-0.971s1.011,0.422,1.023,0.971 C7.714,6.52,7.318,6.955,6.666,6.955z M14.75,13.979h-1.944v-3.467c0-0.807-0.282-1.355-0.985-1.355 c-0.537,0-0.856,0.371-0.997,0.728c-0.052,0.127-0.065,0.307-0.065,0.486v3.607H8.814v-4.26c0-0.781-0.025-1.434-0.051-1.996h1.689 l0.089,0.869h0.039c0.256-0.408,0.883-1.01,1.932-1.01c1.279,0,2.238,0.857,2.238,2.699V13.979z"
                />
              </svg>
            </a>
            <a
              href="https://twitter.com/uxdxconf"
              target="_blank"
              rel="noreferrer noopener"
              className="text-gray-400 hover:text-gray-300"
            >
              <span className="sr-only">Twitter</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/uxdxconf/"
              target="_blank"
              rel="noreferrer noopener"
              className="text-gray-400 hover:text-gray-300"
            >
              <span className="sr-only">Facebook</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  fillRule="evenodd"
                  d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                  clipRule="evenodd"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/uxdxconf/?hl=en"
              target="_blank"
              rel="noreferrer noopener"
              className="text-gray-400 hover:text-gray-300"
            >
              <span className="sr-only">Instagram</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  fillRule="evenodd"
                  d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                  clipRule="evenodd"
                />
              </svg>
            </a>

            <a
              href="https://join.slack.com/t/uxdxcommunity/shared_invite/zt-35pa4p852-BqMGL8z7G3CTP~pd7HqxSw"
              target="_blank"
              rel="noreferrer noopener"
              className="text-gray-400 hover:text-gray-300"
            >
              <span className="sr-only">Slack</span>

              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="m8.843 12.651c-1.392 0-2.521 1.129-2.521 2.521v6.306c0 1.392 1.129 2.521 2.521 2.521s2.521-1.129 2.521-2.521v-6.306c-.001-1.392-1.13-2.521-2.521-2.521z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="m.019 15.172c0 1.393 1.13 2.523 2.523 2.523s2.523-1.13 2.523-2.523v-2.523h-2.521c-.001 0-.001 0-.002 0-1.393 0-2.523 1.13-2.523 2.523z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="m8.846-.001c-.001 0-.002 0-.003 0-1.393 0-2.523 1.13-2.523 2.523s1.13 2.523 2.523 2.523h2.521c0-1.431 0-1.083 0-2.528-.001-1.391-1.128-2.518-2.518-2.518z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="m2.525 11.37h6.318c1.393 0 2.523-1.13 2.523-2.523s-1.13-2.523-2.523-2.523h-6.318c-1.393 0-2.523 1.13-2.523 2.523s1.13 2.523 2.523 2.523z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="m21.457 6.323c-1.391 0-2.518 1.127-2.518 2.518v.005 2.523h2.521c1.393 0 2.523-1.13 2.523-2.523s-1.13-2.523-2.523-2.523c-.001 0-.002 0-.003 0z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="m12.641 2.522v6.325c0 1.392 1.129 2.521 2.521 2.521s2.521-1.129 2.521-2.521v-6.325c0-1.392-1.129-2.521-2.521-2.521-1.392 0-2.521 1.129-2.521 2.521z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="m17.682 21.476c0-1.392-1.129-2.521-2.521-2.521h-2.521v2.523c.001 1.391 1.129 2.519 2.521 2.519s2.521-1.129 2.521-2.521z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="m21.479 12.649h-6.318c-1.393 0-2.523 1.13-2.523 2.523s1.13 2.523 2.523 2.523h6.318c1.393 0 2.523-1.13 2.523-2.523s-1.13-2.523-2.523-2.523z"
                />
              </svg>
            </a>
          </div>

          <p className="mt-8 text-base leading-6 text-gray-400 md:mt-0">
            &copy; {new Date().getFullYear()} Socially Motivated Ltd t/a UXDX
            <br />
            <span className="text-xs">
              13A Belgrave Road, Rathmines, Dublin 6, D06 E9H9, Ireland
              <br />
              Company #: 547304 &middot; VAT #: IE3316959OH
            </span>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
